import { Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as Action from "../../_redux/applicantActions";
import {
  Input,
  SelectInput,
} from "../../../../../_metronic/_partials/controls";
import { TextArea } from "../../../../../_metronic/_partials/controls/forms/TextArea";
import API from "../../../../helpers/devApi";
import * as Yup from "yup";
import { swalError, swalSuccess } from "../../../../helpers/swal";
import * as EmployeeListAction from "../../../employee/_redux/employeeActions";
import Editor from "../../../../../_metronic/_partials/controls/Editor";

const _init = {
  current_salary: "",
  expected_salary: "",
  notice_period: "",
  extracurricular_activities: "",
};

const SalaryInformation = ({ id }) => {
  const dispatch = useDispatch();
  const { experienceList, personalInfo } = useSelector(
    ({ applicant }) => ({
      experienceList: applicant.experienceList,
      personalInfo: applicant.personal_info,
    }),
    shallowEqual
  );
  const [loading, setLoading] = useState(false);
  const [profile, setProfile] = useState(_init);

  // Validation schema
  const validationSchema = Yup.object().shape({
    current_salary: personalInfo?.is_fresher
      ? Yup.number().nullable()
      : Yup.number().required("Current Salary is required"),
    expected_salary: Yup.number().required(
      "Expected Salary (BDT Per Month) is required"
    ),
    notice_period: personalInfo?.is_fresher
      ? Yup.number().nullable()
      : Yup.number().required("Notice Period is required"),
    extracurricular_activities: Yup.string().required(
      "Extracurricular Activities is required"
    ),
  });

  const handleSaveProfile = async (values) => {
    values["current_salary"] =
      values?.current_salary == "" ? null : values?.current_salary;
    values["notice_period"] =
      values?.notice_period == "" ? null : values?.notice_period;

    const response = await API.post(
      "hrms_applicant/save-additional-info/" + id,
      values
    );
    if (response.data.success) {
      swalSuccess(response.data.message);
      dispatch(
        Action.createProfileScore(
          {
            name: ["Salary Information", "Extracurricular activities"],
            applicant_id: id,
          },
          () => {
            dispatch(Action.getApplicantPersonalInfo(id));
            fetchData();
          }
        )
      );
    } else {
      swalError(response.data.message);
    }
  };

  const fetchData = async () => {
    const response = await API.get("hrms_applicant/get-additional-info/" + id);
    if (response.data.success) {
      if (Object.keys(response.data.data).length) {
        setProfile({
          current_salary: response.data.data.current_salary,
          expected_salary: response.data.data.expected_salary,
          notice_period: response.data.data.notice_period,
          extracurricular_activities:
            response.data.data.extracurricular_activities,
        });
      }
    } else {
      swalError(response.data.message);
    }
  };
  useEffect(() => {
    if (id) {
      // get-objective
      fetchData();
    }
  }, [id]);

  return (
    <div className="card card_body_box mb-5">
      <Formik
        initialValues={profile}
        enableReinitialize={true}
        validationSchema={validationSchema}
        onSubmit={(values) => {
          handleSaveProfile(values);
        }}
      >
        {({ handleSubmit, setFieldValue, values, errors, touched }) => (
          <Form>
            <div className="row">
              <div className="col-md-12">
                <div className="card_header_with_edit_btn">
                  <div className="title">
                    <h2>Salary Information</h2>
                  </div>
                </div>

                <hr />
              </div>
            </div>
            <div className="row">
              <div className="col-md-12 mb-4">
                <div className="card">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-4">
                        <Input
                          label={"Current Salary"}
                          isRequired={!personalInfo?.is_fresher}
                          value={values.current_salary}
                          onChange={(e) => {
                            setFieldValue("current_salary", e.target.value);
                          }}
                        />
                        {errors.current_salary && touched.current_salary && (
                          <div className="text-danger">
                            {errors.current_salary}
                          </div>
                        )}
                      </div>
                      <div className="col-md-4">
                        <Input
                          label={"Expected Salary (BDT Per Month)"}
                          isRequired
                          value={values.expected_salary}
                          onChange={(e) => {
                            setFieldValue("expected_salary", e.target.value);
                          }}
                        />
                        {errors.expected_salary && touched.expected_salary && (
                          <div className="text-danger">
                            {errors.expected_salary}
                          </div>
                        )}
                      </div>
                      <div className="col-md-4">
                        <Input
                          label={"Notice Period (In days)"}
                          isRequired={!personalInfo?.is_fresher}
                          value={values.notice_period}
                          onChange={(e) => {
                            setFieldValue("notice_period", e.target.value);
                          }}
                        />
                        {errors.notice_period && touched.notice_period && (
                          <div className="text-danger">
                            {errors.notice_period}
                          </div>
                        )}
                      </div>
                      <div className="col-md-12 mt-4 extracurricular_activities_div">
                        <label className="required">
                          Extra Curricular Activities
                        </label>
                        <Editor
                          editorHtml={values.extracurricular_activities ?? ""}
                          onChange={(val) => {
                            const content = val?.replace(/(<([^>]+)>)/gi, "");
                            if (content) {
                              setFieldValue("extracurricular_activities", val);
                            } else {
                              setFieldValue("extracurricular_activities", "");
                            }
                          }}
                        />

                        {/* <TextArea
                                                    label={"Extra Curricular Activities"}
                                                    isRequired
                                                    value={values.extracurricular_activities}
                                                    onChange={(e) => {
                                                        setFieldValue(
                                                            "extracurricular_activities",
                                                            e.target.value
                                                        );
                                                    }}
                                                /> */}
                        {errors.extracurricular_activities &&
                          touched.extracurricular_activities && (
                            <div className="text-danger">
                              {errors.extracurricular_activities}
                            </div>
                          )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="edit_btn_group d-flex modal-footer m-0 p-0">
              <button
                type="button"
                className="btn btn-primary"
                onClick={handleSubmit}
                disabled={loading}
              >
                Save
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default SalaryInformation;
